import { put, takeLatest } from "redux-saga/effects";

import {
  fetchkycActivityListRequest,
  fetchkycActivityListSuccess,
  fetchkycActivityListFailure,
  kycActivityChangeStatusRequest,
  kycActivityChangeStatusSuccess,
  kycActivityChangeStatusFailure,
  addCommentsForkycActivityRequest,
  addCommentsForkycActivitySuccess,
  addCommentsForkycActivityFailure,
  fetchKycAgreementListRequest,
  fetchKycAgreementListSuccess,
  fetchKycAgreementListFaliure,
  AggrementActivityChangeStatusSuccess,
  AggrementActivityChangeStatusFailure,
  AggrementActivityChangeStatusRequest
} from "redux/reducers/acclgl/kycStatus";

import {
  requestKycStatusList,
  requestForChangeStatus,
  requestForAddComments,
  requestKYCAgreementList,
  requestForAggrementChangeStatus
} from "services/acclgl/kycStatus";

export function* watchkycStatus() {
  yield takeLatest(fetchkycActivityListRequest, fetchkycStatuslist);
  yield takeLatest(kycActivityChangeStatusRequest, changeStatusKycActivity);
  yield takeLatest(AggrementActivityChangeStatusRequest ,changeStatusAggrementActivity)
  yield takeLatest(addCommentsForkycActivityRequest, addCommentKycActivity);
  yield takeLatest(fetchKycAgreementListRequest, fetchKycAgreementList);
}

/**
 *
 * @param {kycActivity list} param0
 */
function* fetchkycStatuslist({ payload }) {
  try {
    const response = yield requestKycStatusList(payload);
    yield put(fetchkycActivityListSuccess(response));
  } catch (error) {
    yield put(
      fetchkycActivityListFailure("Failed to get kyc status activity list")
    );
  }
}

/**
 *
 * @param {kycActivity status change} param0
 */
function* changeStatusKycActivity({ payload }) {
  try {
    const response = yield requestForChangeStatus(payload);
    yield put(kycActivityChangeStatusSuccess(response.data));
  } catch (error) {
    yield put(kycActivityChangeStatusFailure("Failed to get Data"));
  }
}

function* changeStatusAggrementActivity({payload}){
  try{
    const response = yield requestForAggrementChangeStatus(payload);
    yield put( AggrementActivityChangeStatusSuccess(response.data));
  } catch (error){
    yield put(AggrementActivityChangeStatusFailure("Fialed to get Data")) 
  }
}

/**
 *
 * @param {kycActivity add comments} param0
 */
function* addCommentKycActivity({ payload }) {
  try {
    const response = yield requestForAddComments(payload);
    yield put(addCommentsForkycActivitySuccess(response.data));
  } catch (error) {
    yield put(addCommentsForkycActivityFailure("Failed to get Data"));
  }
}

function* fetchKycAgreementList({ payload }) {
  try {
    const response = yield requestKYCAgreementList(payload);
    yield put(fetchKycAgreementListSuccess(response));
  } catch (error) {
    yield put(fetchKycAgreementListFaliure("Failed to get list of Agreements"));
  }
}
